






/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETALLPLANSBASEDONCREATOR
// GETALLPLANSBASEDONCREATOR
const GETALLPLANSBASEDONCREATOR= createAsyncThunk(
  "getAllPlansBasedOnCreator/getAllPlansBasedOnCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPlansBasedOnCreatorSlice = createSlice({
  name: "getAllPlansBasedOnCreatorSlice",
  initialState: {
    getAllPlansBasedOnCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPlansBasedOnCreator: (state) => {
        state.getAllPlansBasedOnCreator.loading = false
        state.getAllPlansBasedOnCreator.error = false
        state.getAllPlansBasedOnCreator.data = []
        state.getAllPlansBasedOnCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPLANSBASEDONCREATOR.fulfilled, (state, action) => {
      state.getAllPlansBasedOnCreator = {
        ...state.getAllPlansBasedOnCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPLANSBASEDONCREATOR.pending, (state, action) => {
      state.getAllPlansBasedOnCreator = {
        ...state.getAllPlansBasedOnCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPLANSBASEDONCREATOR.rejected, (state, action) => {
      state.getAllPlansBasedOnCreator = {
        ...state.getAllPlansBasedOnCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPlansBasedOnCreatorAction = {
    GETALLPLANSBASEDONCREATOR,
};

export { getAllPlansBasedOnCreatorAction };
export default getAllPlansBasedOnCreatorSlice.reducer;
export const {setInitialStateOfgetAllPlansBasedOnCreator} = getAllPlansBasedOnCreatorSlice.actions